import React, { useState } from "react";
import { Avatar, Box, IconButton, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DoneIcon from "@mui/icons-material/Done";

import { Discovery } from "../../types";
import { BorderBox } from "../border-box/BorderBox";

type DiscoveryCardProps = {
  data: Discovery;
};

function copyToClipboard(text: string, setCopied: React.Dispatch<React.SetStateAction<boolean>>) {
  setCopied(true);

  navigator.clipboard.writeText(text);

  setTimeout(() => {
    setCopied(false);
  }, 2000);
}

export const DiscoveryCard: React.FC<DiscoveryCardProps> = ({ data }) => {
  const theme = useTheme();

  const [copied, setCoppied] = useState<boolean>(false);

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          padding: "0rem 1rem", //
          bgcolor: theme.palette.secondary.main,
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.getContrastText(theme.palette.secondary.main), //
          }}
        >
          {data.contractHash}
        </Typography>
        {!copied && (
          <IconButton sx={{ opacity: 0.6, "&:hover": { opacity: 1 } }} onClick={() => copyToClipboard(data.contractHash, setCoppied)}>
            <ContentCopyIcon sx={{ color: theme.palette.getContrastText(theme.palette.secondary.main) }} />
          </IconButton>
        )}
        {copied && (
          <IconButton sx={{ opacity: 1 }} onClick={() => {}} disabled={true}>
            <DoneIcon sx={{ color: theme.palette.text.primary }} />
          </IconButton>
        )}
      </Box>
      <BorderBox color={"secondary"} sx={{ p: 2 }}>
        <Stack direction={"column"} gap={2} sx={{ width: "100%" }}>
          <Stack direction={"column"} gap={0.25} sx={{ width: "100%" }}>
            <Typography component={"label"} sx={{ fontSize: "0.8rem", opacity: 0.6 }}>
              BLOCK ID
            </Typography>
            <Typography component={"label"}>{data.blockId}</Typography>
          </Stack>
          <Stack direction={"column"} gap={0.25} sx={{ width: "100%" }}>
            <Typography component={"label"} sx={{ fontSize: "0.8rem", opacity: 0.6 }}>
              CONTRACT HASH
            </Typography>
            <Typography component={"label"}>{data.contractHash}</Typography>
          </Stack>
          <Stack direction={"row"} gap={1} sx={{ width: "100%" }}>
            <Avatar src={data.avatar} />
            <Stack direction={"column"} gap={0.25} sx={{ width: "100%" }}>
              <Typography component={"label"} sx={{ fontSize: "0.8rem", opacity: 0.6 }}>
                DEVELOPER
              </Typography>
              <Typography component={"label"}>{data.developer}</Typography>
            </Stack>
          </Stack>
        </Stack>
      </BorderBox>
    </Box>
  );
};
